import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";

const url = environment.api;

@Injectable({
  providedIn: "root",
})
export class ParkingService {
  constructor(private http: HttpClient) {}

  parkingBarrierOpen(configKey: string) {
    return this.http.post(url + "parking/barrier/", { key: configKey });
  }
}
